export interface ICONS {
    DASHBOARD: string;
    PROPERTIES: string;
    ASSETMANAGEMENT: string;
    CONTROLS: string;
    PROPERTYSERVICES: string;
    ALARMS: string;
    REPORTS: string;
    SETTINGS: string;
    CHEVRONRIGHT: string;
    CHEVRONLEFT: string;
    NOTIFICATIONS: string;
    ACTIONS: string;
}
export const ICONS = {
    DASHBOARD: 'dashboard',
    PROPERTIES: 'location_city',
    ASSETMANAGEMENT: 'dynamic_form',
    CONTROLS: 'tune',
    PROPERTYSERVICES: 'business',
    ALARMS: 'crisis_alert',
    REPORTS: 'description',
    SETTINGS: 'settings',
    CHEVRONRIGHT: 'chevron_right',
    CHEVRONLEFT: 'chevron_left',
    NOTIFICATIONS: 'notifications_none',
    ACTIONS: 'more_horiz'
} as const;

export const ABBICONS = {
    ADD_USER: 'add-user',
    ADVANCED_SETTINGS: 'advanced-settings',
    ALARM_BELL: 'alarm-bell',
    ALIGN_BOTTOM: 'align-bottom',
    ALIGN_HORIZONTAL_CENTER: 'align-horizontal-center',
    ALIGN_LEFT: 'align-left',
    ALIGN_RIGHT: 'align-right',
    ALIGN_TOP: 'align-top',
    ALIGN_VERTICAL_CENTER: 'align-vertical-center',
    ALIGN: 'align',
    ANALYZE_DOCUMENT: 'analyze-document',
    ANCHOR: 'anchor',
    AUDIO_OFF: 'audio-off',
    AUDIO_ON: 'audio-on',
    BACKGROUND: 'background',
    BAR_CHART: 'bar-chart',
    BATTERY_CHARGING: 'battery-charging',
    BATTERY_EMPTY: 'battery-empty',
    BATTERY_FULL: 'battery-full',
    BATTERY_HALF: 'battery-half',
    BATTERY_HIGH: 'battery-high',
    BATTERY_LOW: 'battery-low',
    BEARING: 'bearing',
    BINARY_DATA: 'binary-data',
    BLUETOOTH: 'bluetooth',
    BOOKMARK: 'bookmark',
    BOOLEAN: 'boolean',
    BRIEFCASE: 'briefcase',
    BRING_TO_FRONT: 'bring-to-front',
    BROADCAST: 'broadcast',
    CALCULATOR: 'calculator',
    CALENDAR: 'calendar',
    CALIBRATION: 'calibration',
    CALL_OUTLINE: 'call-outline',
    CALL: 'call',
    CAMERA: 'camera',
    CARET_DOWN: 'caret-down',
    CARET_LEFT: 'caret-left',
    CARET_RIGHT: 'caret-right',
    CARET_UP: 'caret-up',
    CART: 'cart',
    CERTIFICATE_DOCUMENT_1: 'certificate-document-1',
    CERTIFICATE_DOCUMENT_2: 'certificate-document-2',
    CHAT: 'chat',
    CHECK_MARK_CIRCLE_1: 'check-mark-circle-1',
    CHECK_MARK_CIRCLE_2: 'check-mark-circle-2',
    CHECK_MARK_LIGHT: 'check-mark-light',
    CHECK_MARK: 'check-mark',
    CLOSE_LIGHT: 'close-light',
    CLOSE: 'close',
    CLOUD: 'cloud',
    COMMENT: 'comment',
    COMPUTER: 'computer',
    CONNECT: 'connect',
    CONNECTION: 'connection',
    CONTROLLER_CABINET: 'controller-cabinet',
    CONTROLS_AND_SETTINGS: 'controls-and-settings',
    COPY: 'copy',
    CREATE_BACKUP: 'create-backup',
    CUT: 'cut',
    DASHBOARD: 'dashboard',
    DATA_EDITOR: 'data-editor',
    DATABASE_NEW: 'database-new',
    DATABASE: 'database',
    DECIMAL: 'decimal',
    DELETE_DRIVES: 'delete-drives',
    DEVICES: 'devices',
    DISCONNECT: 'disconnect',
    DISTRIBUTION: 'distribution',
    DOCUMENT_EXCEL: 'document-excel',
    DOCUMENT_PDF: 'document-pdf',
    DOCUMENT_WORD: 'document-word',
    DOCUMENT: 'document',
    DOLLAR: 'dollar',
    DOUBLE_DOWN: 'double-down',
    DOUBLE_LEFT: 'double-left',
    DOUBLE_RIGHT: 'double-right',
    DOUBLE_UP: 'double-up',
    DOWN_ARROW: 'down-arrow',
    DOWN: 'down',
    DOWNLOAD_FROM_CLOUD: 'download-from-cloud',
    DOWNLOAD: 'download',
    DRIVE_CONNECTED: 'drive-connected',
    DRIVE: 'drive',
    DRIVES_ERROR: 'drives-error',
    EDGE: 'edge',
    EDIT: 'edit',
    END_CALL: 'end-call',
    ENVELOPE: 'envelope',
    ERROR_CIRCLE_1: 'error-circle-1',
    ERROR_CIRCLE_2: 'error-circle-2',
    EURO: 'euro',
    EVENT: 'event',
    EXECUTION: 'execution',
    EXPORT: 'export',
    FACTORY: 'factory',
    FIELDBUS: 'fieldbus',
    FILTER: 'filter',
    FOLDER_NEW: 'folder-new',
    FOLDER_OPEN: 'folder-open',
    FOLDER: 'folder',
    FORWARD: 'forward',
    FULLSCREEN: 'fullscreen',
    GAUGE: 'gauge',
    GBP: 'gbp',
    GENERATOR: 'generator',
    GLOBE: 'globe',
    GROUP: 'group',
    HARDWARE_DEVICES: 'hardware-devices',
    HELP_CIRCLE_1: 'help-circle-1',
    HELP_CIRCLE_2: 'help-circle-2',
    HIDE: 'hide',
    HIERARCHY: 'hierarchy',
    HISTORY: 'history',
    HOME: 'home',
    HOUR_GLASS: 'hour-glass',
    IMAGE: 'image',
    IMPORT: 'import',
    INFORMATION_CIRCLE_1: 'information-circle-1',
    INFORMATION_CIRCLE_2: 'information-circle-2',
    IO_DEVICES: 'io-devices',
    IO_SIGNALS: 'io-signals',
    JOG_LINEAR: 'jog-linear',
    JOG_PLANAR: 'jog-planar',
    JOG_REORIENT: 'jog-reorient',
    JOYSTICK: 'joystick',
    KEY: 'key',
    LABEL: 'label',
    LEAD_THROUGH: 'lead-through',
    LEFT_ARROW: 'left-arrow',
    LEFT: 'left',
    LEVEL: 'level',
    LIGHT_BULB: 'light-bulb',
    LINK: 'link',
    LIST_2: 'list-2',
    LIST: 'list',
    LOCATION_OUTLINE: 'location-outline',
    LOCATION: location,
    LOCK_CLOSED: 'lock-closed',
    LOCK_OPEN: 'lock-open',
    LOG_IN: 'log-in',
    LOG_OUT: 'log-out',
    MAGNET: 'magnet',
    MAKE_SAME_HEIGHT: 'make-same-height',
    MAKE_SAME_SIZE: 'make-same-size',
    MAKE_SAME_WIDTH: 'make-same-width',
    MAP: 'map',
    MATRIX: 'matrix',
    MAXIMIZE: 'maximize',
    MAXIMUM_VALUE: 'maximum-value',
    MENU_NARROW: 'menu-narrow',
    MENU: 'menu',
    MICROPHONE_OFF: 'microphone-off',
    MICROPHONE: 'microphone',
    MINIMIZE: 'minimize',
    MINIMUM_VALUE: 'minimum-value',
    MINUS_IN_CIRCLE: 'minus-in-circle',
    MINUS: 'minus',
    MISSED_CALL: 'missed-call',
    MODIFY_RAPID_POSITION: 'modify-rapid-position',
    MOON: 'moon',
    MORE: 'more',
    MOTOR: 'motor',
    NETWORK_SIGNAL_STRENGTH_LEVEL_1: 'network-signal-strength-level-1',
    NETWORK_SIGNAL_STRENGTH_LEVEL_2: 'network-signal-strength-level-2',
    NETWORK_SIGNAL_STRENGTH_LEVEL_3: 'network-signal-strength-level-3',
    NETWORK_STATUS_1: 'network-status-1',
    NETWORK_STATUS_2: 'network-status-2',
    NETWORK_STATUS: 'network-status',
    NETWORK: 'network',
    NEW_DOCUMENT: 'new-document',
    NOT_ALLOWED: 'not-allowed',
    NUMBERED_LIST: 'numbered-list',
    NUMERICALS: 'numericals',
    OBJECT_CONTAINER_1: 'object-container-1',
    OBJECT_CONTAINER_2: 'object-container-2',
    OBJECT: 'object',
    OPEN_IN_NEW_WINDOW: 'open-in-new-window',
    PANEL: 'panel',
    PAPER_CLIP: 'paper-clip',
    PASTE: 'paste',
    PAUSE: 'pause',
    PAYLOAD: 'payload',
    PIE_CHART: 'pie-chart',
    PIN: 'pin',
    PLAY: 'play',
    PLUGIN: 'plugin',
    PLUS_IN_CIRCLE: 'plus-in-circle',
    PLUS: 'plus',
    POP_OUT_WINDOW: 'pop-out-window',
    POWER_ON_OFF: 'power-on-off',
    POWERTRAIN: 'powertrain',
    PRESSURE: 'pressure',
    PREVENT_TURNING_FAULT: 'prevent-turning-fault',
    PRINT: 'print',
    PROGRAM_POINTER: 'program-pointer',
    PUMP: 'pump',
    QR_CODE: 'qr-code',
    RAPID_TASKS: 'rapid-tasks',
    REARRANGE: 'rearrange',
    REDO: 'redo',
    REFRESH: 'refresh',
    REPORTS: 'reports',
    RESET_USER_DATA: 'reset-user-data',
    RESISTOR: 'resistor',
    RESTORE_BACKUP: 'restore-backup',
    REWIND: 'rewind',
    RIGHT_ARROW: 'right-arrow',
    RIGHT: 'right',
    ROBOT_AXIS: 'robot-axis',
    ROBOT_CABINET: 'robot-cabinet',
    ROBOT_TOOL: 'robot-tool',
    ROBOT: 'robot',
    ROTATE_LEFT_180: 'rotate-left-180',
    ROTATE_LEFT_270: 'rotate-left-270',
    ROTATE_LEFT_90: 'rotate-left-90',
    ROTATE_RIGHT_180: 'rotate-right-180',
    ROTATE_RIGHT_270: 'rotate-right-270',
    ROTATE_RIGHT_90: 'rotate-right-90',
    SAVE_AS: 'save-as',
    SAVE: 'save',
    SCREEN: 'screen',
    SEARCH: 'search',
    SELECT: 'select',
    SEND_TO_BACK: 'send-to-back',
    SERVER: 'server',
    SETTINGS: 'settings',
    SHARE: 'share',
    SHORTCUT: 'shortcut',
    SHUFFLE: 'shuffle',
    SKIP_TO_END: 'skip-to-end',
    SKIP_TO_START: 'skip-to-start',
    SLD_1: 'sld-1',
    SLD_2: 'sld-2',
    SMART_GRIPPER: 'smart-gripper',
    SMARTPHONE: 'smartphone',
    SOFTWARE_MODULE: 'software-module',
    SOFTWARE_PROGRAM_AND_MODULES: 'software-program-and-modules',
    SOFTWARE_PROGRAM_EDITOR: 'software-program-editor',
    SOFTWARE_PROGRAM: 'software-program',
    SOFTWARE_RESOURCES: 'software-resources',
    SOFTWARE_ROUTINS: 'software-routins',
    SORT_ALPHABET_DOWN: 'sort-alphabet-down',
    SORT_ALPHABET_UP: 'sort-alphabet-up',
    SORT_ASCENDING: 'sort-ascending',
    SORT_DATE_DOWN_1: 'sort-date-down-1',
    SORT_DATE_DOWN_2: 'sort-date-down-2',
    SORT_DATE_UP_1: 'sort-date-up-1',
    SORT_DATE_UP_2: 'sort-date-up-2',
    SORT_DESCENDING: 'sort-descending',
    SPECIFICATION: 'specification',
    STAIRS: 'stairs',
    STAR: 'star',
    START_INSTALLER: 'start-installer',
    STEP_IN: 'step-in',
    STEP_OUT: 'step-out',
    STEP_OVER: 'step-over',
    STOP: 'stop',
    SUN_2: 'sun-2',
    SUN: 'sun',
    SYNCHRONIZE: 'synchronize',
    SYSTEM: 'system',
    TABLE: 'table',
    TARGET_VALUE_RANGE: 'target-value-range',
    TEMPERATURE_CELSIUS_1: 'temperature-celsius-1',
    TEMPERATURE_CELSIUS_2: 'temperature-celsius-2',
    TEMPERATURE_FAHRENHEIT_1: 'temperature-fahrenheit-1',
    TEMPERATURE_FAHRENHEIT_2: 'temperature-fahrenheit-2',
    TEMPERATURE: 'temperature',
    TEMPLATE_NEW: 'template-new',
    TEMPLATE: 'template',
    TEST: 'test',
    TEXT_BOLD: 'text-bold',
    TEXT_ITALIC: 'text-italic',
    TEXT_UNDERLINE: 'text-underline',
    TEXT: 'text',
    THUMBNAIL_VIEW: 'thumbnail-view',
    TILES: 'tiles',
    TIME_AND_DATE: 'time-and-date',
    TIME: 'time',
    TOUCH: 'touch',
    TRACK_1: 'track-1',
    TRACK_2: 'track-2',
    TRAIN: 'train',
    TRANSFORMER: 'transformer',
    TRASH: 'trash',
    TREE_VIEW: 'tree-view',
    TREND_1: 'trend-1',
    TREND_2: 'trend-2',
    TREND_3: 'trend-3',
    TREND_SCATTER: 'trend-scatter',
    TRIANGLE_DOWN: 'triangle-down',
    TRIANGLE_LEFT: 'triangle-left',
    TRIANGLE_RIGHT: 'triangle-right',
    TRIANGLE_UP: 'triangle-up',
    TURBOCHARGER: 'turbocharger',
    TURN_CLOCKWISE_OFF_TARGET_SPEED: 'turn-clockwise-off-target-speed',
    TURN_CLOCKWISE: 'turn-clockwise',
    TURN_COUNTER_CLOCKWISE_OFF_TARGET_SPEED: 'turn-counter-clockwise-off-target-speed',
    TURN_COUNTER_CLOCKWISE: 'turn-counter-clockwise',
    UNDO: 'undo',
    UNPIN: 'unpin',
    UP_ARROW: 'up-arrow',
    UP: 'up',
    UPLOAD: 'upload',
    USB: 'usb',
    USER_IN_CIRCLE: 'user-in-circle',
    USER_OUTLINE: 'user-outline',
    USER: 'user',
    VIDEO_CAMERA_OFF: 'video-camera-off',
    VIDEO_CAMERA_ON: 'video-camera-on',
    VIDEO_CHAT: 'video-chat',
    VIDEO: 'video',
    VIEW: 'view',
    VOLTAGE: 'voltage',
    WARNING_CIRCLE_1: 'warning-circle-1',
    WARNING_CIRCLE_2: 'warning-circle-2',
    WARNING_TRIANGLE: 'warning-triangle',
    WHEEL: 'wheel',
    WIFI_NETWORK_DISCONNECTED: 'wifi-network-disconnected',
    WRENCH: 'wrench',
    WRITE_TO_DEFAULT_DISABLED: 'write-to-default-disabled',
    WRITE_TO_DEFAULT: 'write-to-default',
    ZOOM_IN: 'zoom-in',
    ZOOM_OUT: 'zoom-out',
}
